import AtlasDropzone from "@/components/form/atlas-dropzone/atlas-dropzone";
import FieldValidator, { FieldValidatorStatus } from "./field-validator";

export default class DropzoneValidator implements FieldValidator {
    name = "dropzone";

    status: FieldValidatorStatus = "error";

    getInvalidMessage(): string {
        return "Aguarde a conclusão do carregamento";
    }

    validate(element: AtlasDropzone): boolean {
        if (element.preview) {
            return true;
        }

        return !element.isUploadingFiles();
    }
}
